export enum NotificationLinkType {
  News = '[link=news:',
  Event = '[link=event:',
  Url = '[link=url:',
  Gamification = '[link=gamification:',
  GamificationNews = '[link=gamificationNews:',
  Survey = '[link=survey:'
}
